// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d84f0526","590":"12e541bf","787":"4b9f4c72"}[chunkId] + ".chunk.js";
};